/**
 * Le lot du compte : ses routes poussées et son onglet (« Ressources »).
 *
 * Inscrites ici, elles rendent l'écran des ports pour un tuteur dont l'interrupteur est relu allumé,
 * hors live ; ailleurs leur écran legacy. Sur les routes partagées avec l'élève (`account`,
 * `settings`, `account-password`, `account-close`, `validate-email`), le pont du tuteur entoure celui
 * de l'élève : l'élève et le parent gardent les leurs.
 *
 * - `account` : il n'y a plus de page « Mon compte », la route ramène à la feuille de profil ;
 * - `account-password`, `validate-email` : les écrans de l'élève, tels quels ; `account-close` : la
 *   page de l'élève, avec la branche du tuteur qui a encore des élèves ;
 * - `tutor/complete-profile` : son étape des créneaux pose l'éditeur de « Ma dispo », sur l'adaptateur
 *   de la semaine et le crochet de lecture du lot dispo ;
 * - reste legacy : `edit-email` (l'élève y garde aussi l'ancien écran, le design system n'a pas de
 *   page de changement d'adresse).
 *
 * Chaque écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../../student/loadedOnRender"
import { type TutorSpaceRouteTable, type TutorSpaceTabTable } from "../tutorSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const accountRoutes: TutorSpaceRouteTable<"account"> = {
    account: loadedOnRender(() => require("./TutorAccountScreen").TutorAccountScreen, "TutorAccountScreen"),
    settings: loadedOnRender(() => require("./TutorSettingsScreen").TutorSettingsScreen, "TutorSettingsScreen"),
    "account-password": loadedOnRender(
        () => require("../../student/Account/StudentPasswordScreen").StudentPasswordScreen,
        "StudentPasswordScreen"
    ),
    "account-close": loadedOnRender(
        () => require("./TutorCloseAccountScreen").TutorCloseAccountScreen,
        "TutorCloseAccountScreen"
    ),
    "validate-email": loadedOnRender(
        () => require("../../student/Account/StudentValidateEmailScreen").StudentValidateEmailScreen,
        "StudentValidateEmailScreen"
    ),
    "tutor/formation": loadedOnRender(
        () => require("./TutorTrainingScreen").TutorTrainingScreen,
        "TutorTrainingScreen"
    ),
    "videos-coaching": loadedOnRender(
        () => require("./TutorCoachingVideosScreen").TutorCoachingVideosScreen,
        "TutorCoachingVideosScreen"
    ),
    "tutoring-invoices": loadedOnRender(
        () => require("./TutorInvoicesScreen").TutorInvoicesScreen,
        "TutorInvoicesScreen"
    ),
    "tutor/complete-profile": loadedOnRender(
        () => require("./TutorCompleteProfileScreen").TutorCompleteProfileScreen,
        "TutorCompleteProfileScreen"
    ),
}

export const accountTabs: TutorSpaceTabTable<"account"> = {
    "tutor-resources": loadedOnRender(
        () => require("./TutorResourcesScreen").TutorResourcesScreen,
        "TutorResourcesScreen"
    ),
}
/* eslint-enable @typescript-eslint/no-require-imports */
